import { getCategoryInfo } from './getCategoryInfo';

/**
 * @description Возвращает категорию для новой ФП. Категория, которая есть на новой, не обязательно будет на старой
 * или ещё где-то. Например, на новой есть категория "coworkingRent", а в других местах её нет, так как это виртуальная
 * категория, существующая только в специфичных ситуациях
 */
export function getCategoryForNewAdd(category: string, coworkingOfferType: string | null): string {
  const { objectType, dealType } = getCategoryInfo(category);

  if (coworkingOfferType && objectType === 'office' && dealType === 'rent') {
    return 'coworkingRent';
  }

  if (objectType === 'cottage') {
    return category.replace('cottage', 'house');
  }

  return category;
}
